/*!
 * Image cropper using HTML5 canvas and imgAreaSelect jQuery plugin
 * version 0.4.0.0
 * 
 * Copyright (c) 2016 Born Digital
 * 
 * available options:
 * width: crop width in pixels
 * height: crop height in pixels
 * constrainCropper: set to true to force the crop box to the aspect Ratio determined by width and height
 * drawBackground: if set to true, background will be filled. Color can be defined with backgroundColor
 * backgroundColor: if drawBackground is set to true, background of the crop result will be filled with this color
 * cropperHeading: prompt displayed before the cropper canvas
 * resultHeading: prompt displayed before the result canvas
 * startHidden: the cropper interface is only shown once an image is selected for the first time
 * hiddenInput: jQuery Selector of the hidden input field that the image URL will be written to
 * remove: destroys the cropper instance by removing the canvas element etc
 * 
 */

(function ($) {
	$.imageCanvasCropper = function (fileinput, options) {
		if (typeof window.FileReader !== 'function') {
			console.log('jQuery imageCanvasCropper fatal error: FileReader not supported in your browser!')
			return;
		}

		var $input = $(fileinput);
		var cropperHeading = document.createElement('label');
		cropperHeading.textContent = options.cropperHeading !== undefined ? options.cropperHeading : "Draw a rectangle to crop";
		var cropperCanvas = document.createElement('canvas');
		cropperCanvas.className = "cropper-interface";
		var resultHeading = document.createElement('label');
		resultHeading.textContent = options.resultHeading !== undefined ? options.resultHeading : "Resulting crop:";
		var resultCanvas = document.createElement('canvas');
		resultCanvas.className = "cropper-result";
		resultCanvas.width = options.width;
		resultCanvas.height = options.height;
		var groupDiv = document.createElement('div');
		if (options.startHidden === true)
			groupDiv.style.display = "none";
		$input.after(groupDiv);
		$(groupDiv).append(cropperHeading, cropperCanvas, resultHeading, resultCanvas);
		var file, fr, img;

		$input.change(function (e) {
			if ($(groupDiv).is(':hidden'))
				$(groupDiv).slideDown();
			$(cropperCanvas).imgAreaSelect({ remove: true });
			file = this.files[0];
			fr = new FileReader();
			fr.onload = createImage;
			fr.readAsDataURL(file);
		});

		function createImage() {
			img = new Image();
			img.onload = imageLoaded;
			img.src = fr.result;
		}

		function imageLoaded() {
			cropperCanvas.width = img.width;
			cropperCanvas.height = img.height;
			var ctx = cropperCanvas.getContext("2d");
			ctx.drawImage(img, 0, 0);
			$(cropperCanvas).imgAreaSelect({
				handles: true,
				onSelectEnd: function (image, selection) {
					if (!selection.width || !selection.height) {
						return;
					}

					// determine true coordinates based on displayed size (necessary for example when canvas size is limited with CSS max-width)
					var factor = img.width / $(cropperCanvas).width();
					var sourceX = selection.x1 * factor,
						sourceY = selection.y1 * factor,
						sourceWidth = selection.width * factor,
						sourceHeight = selection.height * factor;

					drawCrop(sourceX, sourceY, sourceWidth, sourceHeight, selection.width, selection.height);
				}
			});
			if (options.constrainCropper)
				$(cropperCanvas).imgAreaSelect({ aspectRatio: options.width + ":" + options.height });
			drawCrop(0, 0, img.width, img.height, img.width, img.height);
		}

		function drawCrop(sourceX, sourceY, sourceWidth, sourceHeight, selectionWidth, selectionHeight) {
			var c2Ctx = resultCanvas.getContext("2d");
			c2Ctx.clearRect(0, 0, options.width, options.height);

			if (options.drawBackground) {
				c2Ctx.fillStyle = options.backgroundColor;
				c2Ctx.fillRect(0, 0, options.width, options.height);
			}

			// scale selection to desired size and center in result canvas
			var drawX = 0,
				drawY = 0,
				drawWidth = options.width,
				drawHeight = options.height;
			if ((options.width / options.height) > (selectionWidth / selectionHeight)) {
				drawWidth = selectionWidth / (selectionHeight / options.height)
				drawX = Math.floor((options.width - drawWidth) / 2);
			}
			else if ((options.width / options.height) < (selectionWidth / selectionHeight)) {
				drawHeight = selectionHeight / (selectionWidth / options.width)
				drawY = Math.floor((options.height - drawHeight) / 2);
			}

			c2Ctx.drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, drawX, drawY, drawWidth, drawHeight);
			if (options.hiddenInput)
				$(options.hiddenInput).val(resultCanvas.toDataURL());
		}

		function setOptions(newOptions) {
			$.extend(options, newOptions);
		}

		this.destroy = function () {
			$(cropperCanvas).imgAreaSelect({ remove: true });
			$(cropperHeading).remove();
			$(cropperCanvas).remove();
			$(resultHeading).remove();
			$(resultCanvas).remove();
		};

		this.getOptions = function () { return options; };

		this.setOptions = setOptions;
	};

	$.fn.imageCanvasCropper = function (options) {
		options = options || {};

		this.each(function () {
			if ($(this).data('imageCanvasCropper')) {
				if (options.remove) {
					$(this).data('imageCanvasCropper').destroy();
					$(this).removeData('imageCanvasCropper');
				}
				else
					$(this).data('imageCanvasCropper').setOptions(options);
			}
			else if (!options.remove) {
				if (options.enable === undefined && options.disable === undefined)
					options.enable = true;

				$(this).data('imageCanvasCropper', new $.imageCanvasCropper(this, options));
			}
		});

		if (options.instance)
			return $(this).data('imageCanvasCropper');

		return this;
	};

})(jQuery);
